import { Button } from 'reactstrap';
import FeeAction from '../Components/pages-partial/FeeManagement/FeeAction'
import { AlertCircle, Loader } from "react-feather";
import { Btn } from '../AbstractElements';
import moment from 'moment';
import { getFeeStatus } from './fee';
import { capitalizeFirstLetter } from './text';

export const getAttColumn = (
  createAttendance,
  saveAttendanceRecord,
  attendanceLoading,
  showReasonNotation,
  showUpdateReasonModal,
  composeSingleEmail,
  setShowCalenderModal
) => {

  const feeStatus = (data) => {
    const feeScreenshots = data?.courses?.[data?.courseIndex]?.feeScreenshots;
    if (!feeScreenshots) return null;

    const modules = [0, 1];
    const statusPriority = ["notVerified", "pending", "verified"];

    const getModuleStatus = (module) => {
      return statusPriority.find(status =>
        getFeeStatus(feeScreenshots, module, status)
      ) || "unknown";
    };

    const moduleStatuses = modules.map((module) => {
      const status = getModuleStatus(module);
      return {
        label: `Module ${module + 1}`,
        status,
      };
    });

    const tooltip = moduleStatuses
      .map(mod => `${mod.label}: ${capitalizeFirstLetter(mod.status)}`)
      .join(", ");

    const shouldShowIcon = moduleStatuses.some(mod =>
      mod.status === "pending" || mod.status === "notVerified"
    );

    const iconColor = moduleStatuses.some(mod => mod.status === "notVerified")
      ? "#DC3545"
      : moduleStatuses.some(mod => mod.status === "pending")
        ? "#FF8C00"
        : "#6C757D";

    if (!shouldShowIcon) return null;

    return (
      <div
        className="d-flex align-items-center ms-2"
        title={tooltip}
        style={{ cursor: "help" }}
      >
        <AlertCircle
          size={18}
          color={iconColor}
          style={{ flexShrink: 0, fontWeight: 'bold' }}
        />
      </div>
    );
  };
  
  const loadingCondition = (data) => attendanceLoading.email === data?.email && attendanceLoading.loading;

  // const feeStatus = (data, status) => {
  //   return getFeeStatus(data.courses[data.courseIndex].feeScreenshots, module, status) && <div className={`fee-status ${status}`} />
  // }

  // const feeDate = (data) => {
  //   return getFeeDate(data.courses[data.courseIndex].feeScreenshots, module)
  // }

  const data = [
    {
      title: "STUDENT ID",
      dataIndex: "studentId",
      fixed: "left",
      sorter: (a, b) => {
        const valueA = a.studentId;
        const valueB = b.studentId;
        return valueA - valueB;
      },
    },
    {
      title: "NAME",
      fixed: "left",
      render: (data) => {
        return <div className="d-flex align-items-center m-0">{data?.fullName} {feeStatus(data)}</div>
      },
      sorter: (a, b) => {
        const valueA = a.fullName;
        const valueB = b.fullName;
        return valueA.localeCompare(valueB)
      }
    },
    {
      title: "EMAIL",
      dataIndex: "email",
      fixed: "left",
      sorter: (a, b) => {
        const valueA = a.email;
        const valueB = b.email;
        return valueA.localeCompare(valueB)
      },
    },
    {
      title: "NUMBER",
      dataIndex: "contactNo",
    },
    {
      title: "PRESENT",
      render: (data) => {
        return (createAttendance ? (
          <input
            value={"present"}
            id={"present"}
            onClick={() => saveAttendanceRecord("present", data)}
            type="radio"
            disabled={data?.banned || loadingCondition(data)}
            className="present-input"
            checked={data?.attendance?.status === "present"}
          />
        ) : (
          <span
            className={`${data?.attendance?.status === "present" ? "present-span" : ""}`}
          ></span>
        ))
      }
    },
    {
      title: "ABSENT",
      render: (data) => {
        return (createAttendance ? (
          <input
            value={"absent"}
            title={data?.attendance?.status === "absent" && data?.attendance?.reason}
            id={"absent"}
            // onClick={()=>removeAttendanceRecord(studentAttendance.status)}
            onClick={() => saveAttendanceRecord("absent", data)}
            type="radio"
            disabled={data?.banned || loadingCondition(data)}
            className="absent-input"
            checked={data?.attendance?.status === "absent"}
          />
        ) : (
          <>
            {showReasonNotation("absent", data)}
            <span
              onClick={() => showUpdateReasonModal(data)}
              title={data?.attendance?.status === "absent" && data?.attendance?.reason}
              className={`${data?.attendance?.status === "absent" &&
                "absent-span"
                } `}
            ></span>
          </>
        ))
      }
    },
    {
      title: "LEAVE",
      render: (data) => {
        return (createAttendance ? (
          <input
            value={"leave"}
            title={data?.attendance?.status === "leave" && data?.attendance?.reason}
            // onClick={()=>removeAttendanceRecord(studentAttendance.status)}
            id={"leave"}
            onClick={() => saveAttendanceRecord("leave", data)}
            type="radio"
            disabled={data?.banned || loadingCondition(data)}
            className="leave-input"
            checked={data?.attendance?.status === "leave"}
          />
        ) : (
          <>
            {showReasonNotation("leave", data)}
            <span
              onClick={() => showUpdateReasonModal(data)}
              title={data?.attendance?.status === "leave" && data?.attendance?.reason}
              className={`${data?.attendance?.status === "leave" &&
                "leave-span"
                } `}
            ></span>
          </>
        ))
      }
    },
    {
      title: "DATE",
      dataIndex: "attendance",
      render: (data) => {
        return (data?.createdAt && (moment(data?.createdAt?.seconds * 1000).format("L")))
      }
    },
    {
      title: "VIEW ATTENDANCE",
      render: (data) => <Btn attrBtn={{
        onClick: () => setShowCalenderModal(data?.email),
        color: "primary",
        className: "w-100"
      }}>
        View Attendance
      </Btn>
    },
    {
      title: "SEND EMAIL",
      render: (data) => <Btn attrBtn={{
        onClick: () => composeSingleEmail(data),
        color: "primary",
        className: "w-100"
      }}>
        Send Mail
      </Btn>
    }]
  // if (module === 0) {
  //   data.splice(-1, 0, {
  //     title: 'TRANSFER MODULE',
  //     render: (data) =>
  //       <div className='table-course-select'>
  //         {module === 0 && data.courses[data.courseIndex].feeScreenshots.length === 1 &&
  //           <CourseDropdown
  //             module={module}
  //             onChangeCourse={transferFirstModule}
  //             data={data}
  //             type={STUDENT_COURSE_CHANGE}
  //             isSecondModule={true}
  //             courseId={data.courses[data.courseIndex].courseId}
  //           />
  //         }
  //       </div>
  //   });
  //   return data
  // }
  return data
}

export const getAttDataColumn = () => {
  return [
    {
      title: "Present",
      dataIndex: "present",
    },
    {
      title: "Absent",
      dataIndex: "absent",
    },
    {
      title: "Leave",
      dataIndex: "leave",
    },
    {
      title: "No Attendance",
      dataIndex: "no_Attendance",
    },
    {
      title: "Dropped",
      dataIndex: "dropped",
    },
    {
      title: "TOTAL",
      dataIndex: "total",
    },
  ]
}

